/**
 *   Generated file. Do not edit
 */

import { TapVersion } from './models';
import { TapStreamReader, TapStreamWriter } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readTapVersion(): TapVersion;
  }
  export interface TapStreamWriter {
    writeTapVersion(model: TapVersion): TapStreamWriter;
  }
}

TapStreamReader.prototype.readTapVersion = function (): TapVersion {
  const model: Partial<TapVersion> = {};

  model.major = this.readUnsigned(1);

  model.minor = this.readUnsigned(1);

  model.patch = this.readUnsigned(2);

  return model as TapVersion;
};

// TapStreamWriter.prototype.write(model: TapVersion) : TapStreamWriter{
//     return this.writeTapVersion(model)
// }

TapStreamWriter.prototype.writeTapVersion = function (
  model: TapVersion,
): TapStreamWriter {
  this.writeUnsigned(model.major !== undefined ? model.major : 0, 1);

  this.writeUnsigned(model.minor !== undefined ? model.minor : 0, 1);

  this.writeUnsigned(model.patch !== undefined ? model.patch : 0, 2);

  return this;
};
